import { api, formatter, modal } from './util';

/**
 * Plugin for modal dialog which creates a new procedure group.
 */
(function ($) {
	var form;

	var createApiRequest = function () {
		var url = '/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups';
		var operatorFromUrl = /operator=([^&]+)/.exec(window.location);
		var withProductBrothersFromUrl = /with-product-brothers=true/.exec(window.location);
		var data = {
			operator: operatorFromUrl ? operatorFromUrl[1] : 'and',
			withProductBrothers: withProductBrothersFromUrl !== null && withProductBrothersFromUrl.length > 0,
			name: form.find('[name=name]').val().trim(),
		};

		return api.post(url, data).done(function (response) {
			$(document).trigger('procedureGroup.created', response);
		});
	};

	$.fn.createProcedureGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);
			form = $('.modal ' + modalSelector);
			form.validateForm();
			form.find('[type=submit]').apiButton(createApiRequest);

			return false;
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which updates procedure group notification settings.
 */
(function ($) {
	var groupId;
	var form;

	var createApiRequest = function () {
		var url =
			'/users/' +
			encodeURIComponent(api.getUserId()) +
			'/procedure-groups/' +
			encodeURIComponent(groupId) +
			'/notification-settings';
		var data = {
			notificationFrequency: form.find('[name=notifications-enabled]').is(':checked')
				? form.find('[name=notification-frequency]').val()
				: 'disabled',
			deadlinesEnabled: form.find('[name=deadlines-enabled]').is(':checked'),
		};

		return api.put(url, data).done(function (response) {
			$(document).trigger('procedureGroup.notificationSettingsSaved', [groupId, response]);
		});
	};

	function openNotificationSettingsModal(modalSelector) {
		return function () {
			modal.show(modalSelector);

			var procedureGroupContainer = $(this).closest('.procedure-group');
			var notificationFrequency = procedureGroupContainer.data('notification-frequency');
			var enableDeadlines = procedureGroupContainer.data('notification-deadlines-enabled');

			// Initialize the notification settings form.
			groupId = procedureGroupContainer.data('group-id');
			form = $('.modal ' + modalSelector);

			if (notificationFrequency === 'disabled') {
				form.find('[name=notifications-enabled]').prop('checked', false);
			} else {
				form.find('[name=notifications-enabled]').prop('checked', true);
				form.find('[name=notification-frequency]').val(notificationFrequency);
			}

			form.find('[name=deadlines-enabled]').prop('checked', enableDeadlines);

			form.find('[type=submit]').apiButton(createApiRequest);
		};
	}

	$.fn.preOpenNotificationSettingsModal = function (modalSelector) {
		openNotificationSettingsModal(modalSelector).apply(this);
		return this;
	};

	$.fn.procedureNotificationSettingsModal = function (modalSelector) {
		this.click(openNotificationSettingsModal(modalSelector));
		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which renames a procedure group.
 */
(function ($) {
	var groupId;
	var form;

	var createApiRequest = function () {
		var url = '/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups/' + encodeURIComponent(groupId);
		var data = {
			name: form.find('[name=name]').val().trim(),
		};

		return api.put(url, data).done(function (response) {
			$(document).trigger('procedureGroup.renamed', response);
		});
	};

	$.fn.renameProcedureGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);

			var procedureGroupContainer = $(this).closest('.procedure-group');
			var groupName = procedureGroupContainer.find('.procedure-group-name:first').text();

			groupId = procedureGroupContainer.data('group-id');
			form = $('.modal ' + modalSelector);
			form.find('[name=name]').val(groupName);
			form.validateForm();
			form.find('[type=submit]').apiButton(createApiRequest);
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which removes a procedure group.
 */
(function ($) {
	var groupId;

	var createApiRequest = function () {
		return api
			.delete('/users/' + encodeURIComponent(api.getUserId()) + '/procedure-groups/' + encodeURIComponent(groupId))
			.done(function () {
				$(document).trigger('procedureGroup.removed', groupId);
			});
	};

	$.fn.removeProcedureGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);
			groupId = $(this).closest('.procedure-group').data('group-id');
			$('.modal ' + modalSelector + ' [type=submit]').apiButton(createApiRequest);
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for  modal dialog with procedures history.
 */
(function ($) {
	var historyItemsUrl;

	var modalDialog;

	var loadHistoryItems = function () {
		api.get(historyItemsUrl).done(function (response) {
			createHistoryTableRows(response);
			modalDialog.find('.loading').hide();
		});
	};

	var createHistoryTables = function (endYear, startYear) {
		for (var year = endYear; year >= startYear; year--) {
			if (modalDialog.find('table[data-year=' + year + ']').length === 0) {
				modalDialog
					.find('.history')
					.append($('<h3>' + year + '</h3>'))
					.append($('<div class="table"><table data-year="' + year + '"><tbody>'));
			}
		}
	};

	/**
	 * Create history item table rows from data.
	 *
	 * @param {{
	 *     items: {
	 *         id: string,
	 *         procedure: {
	 *             id: string,
	 *             fileNumber: string
	 *         },
	 *         entity: {
	 *             id: string,
	 *             type: string,
	 *             name: string,
	 *         },
	 *         action: string,
	 *         property: string,
	 *         oldValue: string,
	 *         newValue: string,
	 *         created: string
	 *     }[],
	 *     pagination:{
	 *         total:int,
	 *         perPage:int,
	 *         currentPage:int,
	 *         totalPages:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var createHistoryTableRows = function (response) {
		modalDialog.find('.load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);
		modalDialog.find('.history').toggle(response.pagination.total > 0);
		modalDialog.find('.history-empty').toggle(response.pagination.total === 0);

		if (response.items.length > 0) {
			createHistoryTables(
				getYear(response.items[0].created),
				getYear(response.items[response.items.length - 1].created)
			);
		}

		for (var i = 0; i < response.items.length; i++) {
			createHistoryTableRow(response.items[i]);
		}
	};

	/**
	 * Create history item table row.
	 *
	 * @param {{
	 *     id: string,
	 *     procedure: {
	 *         id: string,
	 *         fileNumber: string
	 *     },
	 *     entity: {
	 *         id: string,
	 *         type: string,
	 *         name: string,
	 *     },
	 *     action: string,
	 *     property: string,
	 *     oldValue: string,
	 *     newValue: string,
	 *     created: string
	 * }} historyItem Definition of the history item.
	 */
	var createHistoryTableRow = function (historyItem) {
		var changeName =
			historyItem.action + '.' + historyItem.entity.type + (historyItem.property ? '.' + historyItem.property : '');

		if (changeName === 'update.procedureProduct.finished') {
			if (historyItem.oldValue !== null && historyItem.newValue !== null) {
				changeName += '.updatedDate';
			} else if (historyItem.oldValue !== null) {
				changeName += '.removedDate';
			} else {
				changeName += '.addedDate';
			}
		}

		var changeTemplate = modalDialog.find('.data-template[data-change="' + changeName + '"]');

		if (changeTemplate.length === 0) {
			return;
		}

		var detailUrl = $('body').hasClass('procedure-detail')
			? location.pathname
			: location.pathname + '/' + historyItem.procedure.id + location.search;
		var procedureLink = '<a href="' + detailUrl + '">' + historyItem.procedure.fileNumber + '</a>';
		var changeHtml = changeTemplate
			.html()
			.replace('${procedure.id}', historyItem.procedure.id)
			.replace('${procedure.fileNumber}', historyItem.procedure.fileNumber)
			.replace('${procedure.link}', procedureLink)
			.replace('${entity.name}', historyItem.entity.name);

		switch (changeName) {
			case 'update.procedureProduct.procedureProductStatusId':
				changeHtml = changeHtml
					.replace('${oldValue}', getStatusName(historyItem.oldValue))
					.replace('${newValue}', getStatusName(historyItem.newValue));
				break;

			case 'update.procedureProduct.finished.updatedDate':
				changeHtml = changeHtml
					.replace('${oldValue}', formatter.formatDate(historyItem.oldValue))
					.replace('${newValue}', formatter.formatDate(historyItem.newValue));
				break;

			case 'update.procedureProduct.finished.removedDate':
				changeHtml = changeHtml.replace('${oldValue}', formatter.formatDate(historyItem.oldValue));
				break;

			case 'update.procedureProduct.finished.addedDate':
				changeHtml = changeHtml.replace('${newValue}', formatter.formatDate(historyItem.newValue));
				break;
		}

		var tableRow = $('<tr>');
		tableRow.append($('<td>').text(formatter.formatDate(historyItem.created)));
		tableRow.append($('<td>').html(changeHtml));

		modalDialog.find('table[data-year=' + getYear(historyItem.created) + '] tbody').append(tableRow);
	};

	var getYear = function (date) {
		return new Date(date).getFullYear();
	};

	var getStatusName = function (statusId) {
		return $('.procedure-product-status[data-status-id="' + statusId + '"]').data('status-name');
	};

	$.fn.proceduresHistoryModal = function (modalSelector, url) {
		this.click(function () {
			modal.show(modalSelector);

			historyItemsUrl = url;
			modalDialog = $('.modal ' + modalSelector);
			modalDialog.find('.btn-load-more').loadMore(url, createHistoryTableRows);

			loadHistoryItems();

			return false;
		});

		return this;
	};
})(jQuery);
